<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network, store} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    import DekoRalColor from "../../parts/DekoRalColor.svelte";

    const user = store('credential', 'getAuth');
    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let title = item.title.split(' ', 3)

            const calc_name = (calc?.alt?.[$user.idSklad] ?? false);
            if (calc_name) {
                title = item.title.replace(calc_name, calc.title).split(' ', 3)
            }

            if (APP_TYPE === 'moskitoscompany') {
                title = item.title.replace('Москитная система Pro 40', 'Smart').split(' ', 3)
            }

            width.set(title[1].split('x')[0]);
            height.set(title[1].split('x')[1]);
            ind2.set(title[2]);

            let ind1Str = porog.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));

            switch (ind1Str) {
                case 'порог рамный':
                    ind1 = 'Нет';
                    break;

                case 'порог низкий':
                    ind1 = 'Есть';
                    break;
            }

            ind3 = otkrivanie.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
            ind4 = Object.keys(uplotnenie).find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
            webtype.set(webtypes.find((el) => item.title.toLowerCase().includes(el.toLowerCase())));
            count.set(+item.quantity);
            comment.set(item.comment);
            fetchData = await fetch($ind2);
            change();
        }
    };

    const otkrivanie = [
        'Створка влево',
        'Створка сверху вниз',
        'Створка снизу вверх',
        'Створка вправо',
        'Створка от краев к середине'
    ];

    const uplotnenie = options.uplotnenie || {
        'Без уплотнения' :'Без уплотнения',
        'Щеточный уплотнитель' :'Щеточный уплотнитель',
        'Магнитный уплотнитель' : 'Магнитный уплотнитель'
    };

    const porog = [
        'порог рамный',
        'порог низкий'
    ];

    const color = options.color || {
        'Антрацит': 'Антрацит',
        'Белый': 'Белый',
        'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
        'Неокрашенный': 'Неокрашенный',
        'Цветной': 'Цветной',
    };
    const webtypes = options.webtype || [
        'Обычная',
    ];

    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('Smart', '', color);
        let options = await network.fetch_ind('Smart');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '1000'),
        height = parameter('height', '2000'),
        ind1 = 'Нет',
        ind2 = parameter('color', 'Белый'), // цвет
        ind3 = 'Створка влево', // открывание
        ind4 = 'Без уплотнения', // уплотнитель
        webtype = parameter('webtype', 'Обычная'), // тип сетки плиссе
        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);

    let
        montage_item,
        montage_price = 1;

    const changeInd2 = () => {
        fetchData = fetch($ind2)
    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,
            w = +$width,
            h = +$height,
            packing_items = []
        ;

        let ind1Str;

        switch (ind1) {
            case 'Нет':
                ind1Str = 'порог рамный';
                break;

            case 'Есть':
                ind1Str = 'порог низкий';
                break;
        }

        const calc_name = calc?.alt?.[$user.idSklad] ?? calc.title

        let result = {
            type: 'smart',
            name: calc_name,
            subname: [
                $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ', $webtype, ' ', ind1Str, ' ', ind4
            ].join(''),
            title: [
                calc_name, ' ', $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ', $webtype, ' ', ind1Str, ' ', ind4
            ].join(''),
            params: {
                ind1: ind1,
                ind2: $ind2,
                ind3: ind3,
                ind4: $width,
                ind5: $height,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 26  //указывает Id категории изделий
        };

        let nacenka = 1


        const buf = data.result.find((el) => el.name.includes('аценка на крупно габарит'))
        if (buf) {

            const wn = parseInt(buf.ind1)
            const hn = parseInt(buf.ind3)

            if (wn && hn && w >= wn && h >= hn) {
                nacenka = 1 + (buf.procentSpisania / 100)
            }
        }

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.includes('профиль рамы')) {

                switch (ind1) {
                    case 'Нет': { //без порожка
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                            case 'Створка от краев к середине':
                                kolvo = (((w - 40) * 2 + (h - 78) * 2) / 1000).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = (((w - 78) * 2 + (h - 40) * 2) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }
                    case 'Есть': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                            case 'Створка от краев к середине':
                                kolvo = (((w - 40) * 1 + (h - 60) * 2) / 1000).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = (((w - 78) * 1 + (h - 40) * 2) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }
                }
            }

            if (name.includes('профиль створки')
                || (name.includes('еточный') && ind4.toLowerCase().includes('еточный'))) {
                switch (ind1) {
                    case 'Нет': { //без порожка
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':

                                kolvo = ((h - 85) / 1000).toFixed(3);
                                break;

                            case 'Створка от краев к середине':
                                kolvo = ((h - 85) / 1000 * 2).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = ((w - 85) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }
                    case 'Есть': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((h - 65) / 1000).toFixed(3);
                                break;
                            case 'Створка от краев к середине':
                                kolvo = ((h - 65) / 1000 * 2).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = ((w - 85) / 1000).toFixed(3);
                                break;
                        }

                        break;
                    }
                }
            }

            if (name.includes('магнит в раму') && ind4.toLowerCase().includes('магнит') && ind3 != 'Створка от краев к середине') {
                switch (ind1) {
                    case 'Нет': { //без порожка
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((h - 85) / 1000).toFixed(3);
                                break;
                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = ((w - 85) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }
                    case 'Есть': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((h - 65) / 1000 ).toFixed(3);
                                break;
                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = ((w - 85) / 1000 ).toFixed(3);
                                break;
                        }
                        break;
                    }
                }
            }

            if (name.includes('магнит smart') && ind4.toLowerCase().includes('магнит')) {
                switch (ind1) {
                    case 'Нет': { //без порожка
                        switch (ind3) {
                            case 'Створка от краев к середине':
                                kolvo = ((h - 85) / 1000 * 2).toFixed(3);
                                break;
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((h - 85) / 1000).toFixed(3);
                                break;
                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = ((w - 85) / 1000).toFixed(3);
                                break;

                        }
                        break;
                    }
                    case 'Есть': {
                        switch (ind3) {
                            case 'Створка от краев к середине':
                                kolvo = ((h - 65) / 1000 * 2).toFixed(3);
                                break;
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((h - 65) / 1000 ).toFixed(3);
                                break;
                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = ((w - 85) / 1000 ).toFixed(3);
                                break;
                        }
                        break;
                    }
                }
            }

            if (name.includes('сетка мс плиссе')) {
                switch (true) {
                    case $webtype === 'Обычная' && (name.includes('антипыль') || name.includes('антикошка') || name.includes('антимошка')):
                        return;

                    case $webtype === 'Антипыль' && !name.includes('антипыль'):
                        return;

                    case $webtype === 'Антимошка' && !name.includes('антимошка'):
                        return;

                    case $webtype === 'Антикошка' && !name.includes('антикошка'):
                        return;
                }
                let k = 1;
                if (name.includes('антипыль') || name.includes('антикошка')) {
                    k = 1.1;
                }
                let wave;
                if (ind1 === 'Нет') { //без порожка
                    switch (ind3) {
                        case 'Створка влево':
                        case 'Створка вправо':
                            wave = Math.ceil((w * 45 / 1100) * 1.1);
                            kolvo = ((h - 45) / 1000 * wave * 0.042 * k).toFixed(3);
                            break;

                        case 'Створка от краев к середине':
                            wave = Math.ceil(w / 40);
                            kolvo = ((h - 45) / 1000 * wave * 0.042 * 2  * k).toFixed(3);
                            break;
                        default:  //Створка вертикал
                            wave = Math.ceil(h * 45 / 1100 * 1.1);
                            kolvo = ((w - 45) / 1000 * wave * 0.042  * k).toFixed(3);
                            break;
                    }
                } else {
                    switch (ind3) {
                        case 'Створка влево':
                        case 'Створка вправо':
                            wave = Math.ceil(w * 45 / 1100 * 1.1 );
                            kolvo = ((h - 25) / 1000 * wave * 0.042 * k).toFixed(3);
                            break;

                        case 'Створка от краев к середине':
                            wave = Math.ceil(w / 40);
                            kolvo = ((h - 25) / 1000 * wave * 0.042 * 2 * k).toFixed(3);
                            break;
                        default:  //Створка вертикал
                            wave = Math.ceil(h * 45 / 1100 * 1.1);
                            kolvo = ((w - 25) / 1000 * wave * 0.042 * k).toFixed(3);
                            break;
                    }

                }

                if (APP_TYPE === 'axis-plisse') {
                    kolvo= kolvo * 1.2;
                }

            }

            if (name.includes('пвх лента') || name.toLowerCase().includes('вставка внутренняя') || name.toLowerCase().includes('скотч')) {
                let wave;
                if (ind1 === 'Нет') { //без порожка
                    switch (ind3) {
                        case 'Створка влево':
                        case 'Створка вправо':
                            kolvo = ((h - 45) / 1000 * 2).toFixed(3);
                            break;
                        case 'Створка от краев к середине':

                            kolvo = ((h - 45) / 1000 * 4).toFixed(3);
                            break;
                        default:  //'Створка вертикал
                            kolvo = ((w - 45) / 1000 * 2).toFixed(3);
                            break;
                    }
                } else {
                    switch (ind3) {
                        case 'Створка влево':
                        case 'Створка вправо':
                            kolvo = ((h - 25) / 1000 * 2).toFixed(3);
                            break;
                        case 'Створка от краев к середине':

                            kolvo = ((h - 25) / 1000 * 4).toFixed(3);
                            break;
                        default:  //'Створка вертикал
                            kolvo = ((w - 25) / 1000 * 2).toFixed(3);
                            break;
                    }
                }
            }

            if (name.includes('угол рамный')) {

                if (ind1 === 'Нет') { //без порожка
                    kolvo = 4;
                } else {
                    kolvo = 2;
                }
            }

            if (name.includes('угол под ')) {

                if (ind1 === 'Нет') { //без порожка

                } else {
                    kolvo = 2;
                }
            }

            if (name.includes('порог') && !name.includes('угол под')) {

                if (ind1 === 'Нет') { //без порожка

                } else {
                    switch (ind3) {
                        case 'Створка влево':
                        case 'Створка вправо':
                        case 'Створка от краев к середине':
                            kolvo = ((w - 40) / 1000).toFixed(3);
                            break;

                        case 'Створка сверху вниз':
                        case 'Створка снизу вверх':
                            kolvo = ((w - 40) / 1000).toFixed(3);
                            break;
                    }
                }
            }

            let c, k;
            switch (ind3) {
                case 'Створка влево':
                case 'Створка вправо':
                case 'Створка от краев к середине':
                    k = h;
                    break;

                default:  //'Створка вертикал
                    k = w;
                    break;
            }

            switch (true) {
                case (k - 78 - 100) < 1200: {
                    c = 2;
                    break;
                }
                case (k - 78 - 100) <= 1600: {
                    c = 3;
                    break;
                }
                case (k - 78 - 100) <= 2300: {
                    c = 4;
                    break;
                }
                default: {
                    c = 5;
                    break;
                }
            }

            /*if (name.includes('нить мс плиссе')) {

                switch (ind3) {
                    case 'Створка от краев к середине':
                        kolvo = (((w + h) * 2 + 400) * 2 / 1000 * c).toFixed(3);
                        break;
                    default:  //'Створка вертикал
                        kolvo = (((w + h) * 2 + 400) / 1000 * c).toFixed(3);
                        break;
                }


            }*/
            if (name.includes('нить мс плиссе')) {
                let c, k, d;

                d = h;
                if (ind3 === 'Створка сверху вниз' || ind3 === 'Створка снизу вверх') {

                    d = w;
                }



                if (ind1 === 'Нет') { //без порожка

                    switch (true) {
                        case d - 78 - 100 <= 1200: {
                            c = 2;
                            break;
                        }
                        case (d - 78 - 100 <= 1600): {
                            c = 3;
                            break;
                        }
                        case d - 78 - 100 <= 2300: {
                            c = 4;
                            break;
                        }
                        default: {
                            c = 5;
                            break;
                        }
                    }

                } else {

                    switch (true) {
                        case d - 60 - 100 <= 1200: {
                            c = 2;
                            break;
                        }
                        case (d - 60 - 100 <= 1600): {
                            c = 3;
                            break;
                        }
                        case d - 60 - 100 <= 2300: {
                            c = 4;
                            break;
                        }
                        default: {
                            c = 5;
                            break;
                        }
                    }
                }

                switch (ind3) {
                    case 'Створка от краев к середине':
                        k = 2;
                        break;

                    default:
                        k = 1;
                        break;
                }

                kolvo = (((w + h)* 2 + 400) / 1000 * c * k).toFixed(3);
            }



            if (name.includes('заклеп') || name.toLowerCase().includes('люверс')) {

               /* switch (ind3) {
                    case 'Створка от краев к середине':
                        kolvo = (c * 4 * 2).toFixed(3);
                        break;
                    default:  //'Створка вертикал
                        kolvo = (c * 4).toFixed(3);
                        break;
                }*/


                let c, k, d;

                d = h;
                if (ind3 === 'Створка сверху вниз' || ind3 === 'Створка снизу вверх') {

                    d = w;
                }

                switch (true) {
                    case d + 80 < 1500: {
                        c = 4;
                        break;
                    }
                    case (d + 80 >= 2500 && d + 80 < 2700): {
                        c = 8;
                        break;
                    }
                    case d + 80 >= 2700: {
                        c = 10;
                        break;
                    }
                    default: {
                        c = 6;
                        break;
                    }
                }

                switch (ind3) {
                    case 'Створка от краев к середине':
                        k = 2;
                        break;

                    default:
                        k = 1;
                        break;
                }

                kolvo = (c * k * 2).toFixed(3);

            }
            if (name.includes('гвоздь')) {

                switch (ind3) {
                    case 'Створка от краев к середине':
                        kolvo = 4;
                        break;
                    default:  //'Створка вертикал
                        kolvo = 2;
                        break;
                }

            }
            if (name.includes('пвх пятка')) {
                switch (ind3) {
                    case 'Створка от краев к середине':
                        kolvo = 4;
                        break;
                    default:  //'Створка вертикал
                        kolvo = 2;
                        break;
                }
            }

            if (name.includes('заглушка')) {
                if (ind1 === 'Нет') { //без порожка
                    kolvo = 4;
                } else {
                    kolvo = 2;
                }
                // if (name.includes('универсальная')) {
                //     kolvo = kolvo * 2;
                // }
            }

            if (name.includes('работа')) {
                kolvo = 1;
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price * nacenka) ;
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price * nacenka);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost * nacenka);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }

            if (name.includes('упаковка')) {
                packing_items.push(item);
            }
        });



        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);



        let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
        montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);

        dispatch('mounting', {item: montage_item, price: montage_price});
        dispatch('packing', {items: packing_items, multiplier: w * h / 1000000});
        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row d-flex">
            <div class="col-12 col-sm-7 ">
                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase"> { ($width > (options.recomend && options.recomend.width ? options.recomend.width : 6000) || $height > (options.recomend && options.recomend.height ? options.recomend.height : 6000)) ? 'Изделие с данным размером не подлежит гарантии' : '' }</span>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Направление</label>
                                <select class="form-control form-select" bind:value={ind3}>
                                    {#each otkrivanie as item}
                                        <option value="{item}">{item}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>

                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет</label>
                                <select class="form-control form-select" bind:value={$ind2} on:change={() => {changeInd2(); change()}}>
                                    {#each Object.entries(color) as [value]}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>

                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип сетки</label>
                                <select class="form-control form-select" bind:value={$webtype} >
                                    {#each webtypes as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>

                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Шир., мм ≥ { options.recomend && options.recomend.width ? options.recomend.width : 6000 }</label>

                                <input
                                        type="number"
                                        class="form-control text-center { $width > (options.recomend && options.recomend.width ? options.recomend.width : 6000) ? 'text-danger' : '' }"
                                        step="10"
                                        min="300"
                                        max="{ options.max && options.max.width ? options.max.width : 6000 }"
                                        bind:value={$width}
                                        use:validate_int={$width}

                                >
                            </div>
                        </div>

                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Выс., мм ≥ { options.recomend && options.recomend.height ? options.recomend.height : 3000 }</label>
                                <input
                                        type="number"
                                        class="form-control text-center { $height > (options.recomend && options.recomend.height ? options.recomend.height : 3000) ? 'text-danger' : '' }"
                                        step="10"
                                        min="300"
                                        max="{ options.max && options.max.height ? options.max.height : 3000 }"
                                        bind:value={$height}
                                        use:validate_int={$height}>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Порог</label>
                                <select class="form-control form-select" bind:value={ind1}>
                                    <option value="Нет">Рамный 40мм</option>
                                    <option value="Есть">Низкий 10мм</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 {APP_TYPE === 'axis-plisse' ? 'd-none' : ''}">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Уплотнитель</label>
                                <select class="form-control form-select" bind:value={ind4}>
                                    {#each Object.entries(uplotnenie) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-5 text-center d-flex order-last  order-sm-first justify-content-around">
                <img style="max-height: 250px" class="img-fluid  p-3" src="/img/plisse/ind3/{ind3.toLowerCase().replaceAll(' ', '-')}-{$ind2.toLowerCase()}.jpg"/>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
            <RalColor color={$ind2} bind:comment={$comment}/>
            <DekoRalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}

